// THIS FILE IS AUTO-GENERATED - DO NOT EDIT. You can edit the build script.

package pl.decks.personal.pages.blog

import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import pl.decks.personal.components.layouts.blog.BlogPostData

@InitSilk
fun initBlogPostRegistry(ctx: InitSilkContext) {
    BlogPostRegistry.registerEntry(
        route = "/blog/2026/zero-positive",
        blogPostData = BlogPostData(
            title = "Runs in my veins",
            description = "No cure. But mostly harmless.",
            heroImage = "/images/blog/2026/zero-plus/diag_test.png",
            date = "2026-06-18",
            author = "@me",
            tags = listOf("diagnosis", "habits", "code", "compound-effects"),
        ),
    )
}
